import { css } from 'styled-components';

import { tokens } from 'containers/Intelligence/theme';

/**
 * PLA-8815: the two in-card heading treatments. They used to be one 11px `panelHeading`, which was
 * wrong for every uppercase block label — the scene graph shows two genuinely different elements,
 * each verified on two cards.
 *
 * The old single treatment was sized by measuring cap height off `Group 40450.svg` and reading 11px.
 * That is a pixel measurement of an outlined export; the scene graph says 10px. A read beats a
 * measurement.
 */

/**
 * The uppercase in-card block label — `LIFECYCLE STAGE DISTRIBUTION` (`589:32350`),
 * `SOURCE & SYNC EVIDENCE` (`589:32273`).
 *
 * The values are two-card agreement inside Customer Base and are NOT confirmed uniform across
 * sections: a Rewards & Loyalty heading (`589:28676`) reads 12/700/lh 100%/`#AEBBD0`, agreeing only
 * on the 0.8px tracking — and that node may itself be misattributed, since its band carries payments
 * vocabulary. A section that measures its own headings should override rather than restyle to these.
 */
export const blockHeading = css`
  margin: 0;
  font-size: ${tokens.type['block-heading-size']};
  font-weight: ${tokens.type['block-heading-weight']};
  line-height: ${tokens.type['block-heading-line']};
  letter-spacing: ${tokens.type['block-heading-tracking']};
  text-transform: uppercase;

  /* The content scope colours h1-h6 through a descendant rule, which outranks a plain single-class
     declaration — so every one of these headings was rendering at text-primary regardless of what
     it asked for. The doubled class is what makes the hue land. */
  && {
    color: ${tokens.color['text-caption']};
  }
`;

/**
 * The sentence-case box heading — `Why this result?` (`589:32325`), `Evidence` (`589:32329`).
 * Brighter and larger than the block label, and never uppercased.
 */
export const whyboxHeading = css`
  margin: 0;
  font-size: ${tokens.type['whybox-heading-size']};
  font-weight: ${tokens.type['whybox-heading-weight']};
  line-height: ${tokens.type['whybox-heading-line']};

  && {
    color: ${tokens.color['whybox-heading']};
  }
`;

/**
 * The name the other sections' blocks already import. Kept pointing at `blockHeading` so they pick
 * the corrected values up without their files being edited by this change.
 */
export const panelHeading = blockHeading;
